import React, { useMemo, useState, useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import heroImage from '../images/hero.png';
import androidIcon from '../images/svgs/android.svg';
import appstoreIcon from '../images/svgs/appstore.svg';
import PageMeta from '../seo/PageMeta';
import { buildAppStoreStructuredData } from '../seo/structuredData';

function AppStore() {
  const appStoreStructuredData = useMemo(
    () => [buildAppStoreStructuredData()],
    []
  );

  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  if (!content || !content.appStores) return <div></div>;

  const handleStoreClick = (storeName) => {
    // Analytics event tracking
    if (window.gtag) {
      window.gtag('event', 'app_store_click', {
        store_name: storeName,
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <>
      <PageMeta path="/app" structuredData={appStoreStructuredData} />
      <Menu />
      
      <Container className='app-store-page py-5'>
        <Row className='justify-content-center text-center'>
          <Col xs={12} md={8} lg={6}>
            {/* Hero Section */}
            <div className='mb-5'>
                <Image 
                    fluid 
                    src={heroImage} 
                    alt="eGodziny App" 
                    className='mb-4'
                    style={{ maxWidth: '300px' }}
                />
                <h1 className='display-4 fw-bold mb-3'>
                    {content.appStores.title}
                </h1>
                <p className='lead text-muted mb-4'>
                    {content.appStores.subtitle}
                </p>
            </div>

            {/* Store Links */}
            <div className='store-links mb-5'>
              <Row className='g-4 justify-content-center'>
                <Col xs={12} sm={6} md={5}>
                  <div className='store-button-container'>
                    <a
                       className='store-button d-block'
                       href="https://play.google.com/store/apps/details?id=pl.egodziny.egodziny_mobile_app&pcampaignid=web_share"
                       target="_blank"
                       rel="noopener noreferrer"
                       onClick={() => handleStoreClick('google_play')}
                    >
                       <Image 
                         src={androidIcon} 
                         alt="Google Play" 
                         className='store-icon'
                       />
                     </a>
                    <div className='store-label mt-3'>
                       <div className='text-muted small'>{content.appStores.downloadFrom}</div>
                       <div className='fw-bold'>{content.appStores.googlePlay}</div>
                     </div>
                  </div>
                </Col>
                
                <Col xs={12} sm={6} md={5}>
                  <div className='store-button-container'>
                    <a
                       className='store-button d-block'
                       href="https://apps.apple.com/pl/app/egodziny/id6738045022?l=pl"
                       target="_blank"
                       rel="noopener noreferrer"
                       onClick={() => handleStoreClick('app_store')}
                    >
                       <Image 
                         src={appstoreIcon} 
                         alt="App Store" 
                         className='store-icon'
                       />
                     </a>
                    <div className='store-label mt-3'>
                       <div className='text-muted small'>{content.appStores.downloadFrom}</div>
                       <div className='fw-bold'>{content.appStores.appStore}</div>
                     </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* Back to Home */}
            <div className='text-center'>
                <Link to="/" className='btn btn-outline-primary'>
                {content.appStores.backToHome}
               </Link>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}

export default AppStore;
